enum ActionType {
    REQUEST_LOCATIONS = '[CORE/LOCATIONS] GET LOCATIONS',
    REFRESH_LOCATIONS = '[CORE/LOCATIONS] REFRESH LOCATIONS',
    SET_REFRESH_LOCATIONS = '[CORE/LOCATIONS] SET REFRESH LOCATIONS',
    SET_LOCATIONS = '[CORE/LOCATIONS] SET LOCATIONS',
}

export default ActionType
